import React from 'react';
import { motion } from 'framer-motion';
import { workProcess } from '../data/mockData';

const HowWeWorkSection = () => {
  return (
    <section id="process" data-testid="process-section" className="py-28 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#3B82F6]/[0.04] rounded-full blur-[80px]" />
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/20 mb-5">
            <span className="text-xs font-semibold text-[#3B82F6] uppercase tracking-wider">How It Works</span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-5">
            <span className="text-gradient">3 Simple Steps</span> to Protect Your Logo
          </h2>
          <p className="text-[#A1A1AA] leading-relaxed text-lg">
            Our streamlined process makes logo trademark registration simple and stress-free.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5">
          {workProcess.map((step, index) => (
            <motion.div key={step.id}
              className="glass-card rounded-2xl p-7 relative group hover:border-[#3B82F6]/30 transition-all"
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}>
              <div className="text-gradient font-heading text-5xl font-semibold opacity-30 group-hover:opacity-80 transition-all duration-500 mb-4 group-hover:scale-110 origin-left">
                {step.step}
              </div>
              <h3 className="font-heading text-lg font-semibold text-white mb-3">{step.title}</h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed">{step.description}</p>
              {index < workProcess.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-[2px] bg-gradient-to-r from-[#3B82F6]/30 to-transparent" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
